// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"dV-z","inlineTitle":"eV-z","sponsoredAdsWrapper":"fV-z","marketplaceRecosWrapper":"gV-z"};